// Uitlijning van een knoppenrij in de pagina-inhoud (app-buttons-row).

export const buttonsRowAlign = {
    start: 'start',
    center: 'center',
    end: 'end',
} as const;

export type TButtonsRowAlign = (typeof buttonsRowAlign)[keyof typeof buttonsRowAlign];
